import axios from 'axios'
import config from '../config/app'
import Helper from '../helper/helper'
const PATH = '/event'

const eventAPI = {
  createEvent (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'post',
        url: config.server + PATH + '/create-event',
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getAll (additionalFields) {
    return this.get({}, additionalFields)
  },
  get (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + PATH + '/get?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getTimeZones (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/timezones', { params: data }).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteCategory (id) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + PATH + '/delete-category/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteEvent (id) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + PATH + '/delete-event/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  createCategory (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + PATH + '/create-category',
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCategories () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + PATH + '/categories').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateCategory (id, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'post',
        url: config.server + PATH + '/update-category/' + id,
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCategoryById (id) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + PATH + '/category/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getEventById (id) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + PATH + '/' + id).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateEvent (id, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'post',
        url: config.server + PATH + '/update-event/' + id,
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default eventAPI



// WEBPACK FOOTER //
// ./src/api/event.js